// Vendors
import gsap from "gsap";
// Level
import { LevelObject } from "shared/levels";
// Game Instance
import { Game } from "screens/game/game";
// Menu Instance
import { Main } from "screens/main";
// Config
import { DefaultConfig } from "shared/config";
// Models
import { Block } from "shared/model";
// State Mashine
import { BlockStateMashine } from "shared/state/block";

export class ClusterService {
    // private clusters = [];
    // private moves = [];

    // public resolveClusters(): void {
    //     // Check for clusters
    //     this.findClusters();
    //     // While there are clusters left
    //     while (this.clusters.length > 0) {

    //         // Remove clusters
    //         this.removeClusters();

    //         // // Shift tiles
    //         this.shiftTiles();

    //         // Check if there are clusters left
    //         this.findClusters();
    //     }
    // }

    // public findClusters(): void {
    //     // Reset clusters
    //     this.clusters = []

    //     // Find horizontal clusters
    //     for (let j = 0; j < LevelObject.rows; j++) {
    //         // Start with a single tile, cluster of 1
    //         let matchlength = 1;
    //         for (let i = 0; i < LevelObject.columns; i++) {
    //             let checkcluster = false;

    //             if (i == LevelObject.columns - 1) {
    //                 // Last tile
    //                 checkcluster = true;
    //             } else {
    //                 // Check the type of the next tile
    //                 if (LevelObject.tiles[i][j].type == LevelObject.tiles[i + 1][j].type &&
    //                     LevelObject.tiles[i][j].type != -1) {
    //                     // Same type as the previous tile, increase matchlength
    //                     matchlength += 1;
    //                 } else {
    //                     // Different type
    //                     checkcluster = true;
    //                 }
    //             }

    //             // Check if there was a cluster
    //             if (checkcluster) {
    //                 if (matchlength >= 3) {
    //                     // Found a horizontal cluster
    //                     this.clusters.push({
    //                         column: i + 1 - matchlength, row: j,
    //                         length: matchlength, horizontal: true
    //                     });
    //                 }

    //                 matchlength = 1;
    //             }
    //         }
    //     }

    //     // Find vertical clusters
    //     for (let i = 0; i < LevelObject.columns; i++) {
    //         // Start with a single tile, cluster of 1
    //         let matchlength = 1;
    //         for (let j = 0; j < LevelObject.rows; j++) {
    //             let checkcluster = false;

    //             if (j == LevelObject.rows - 1) {
    //                 // Last tile
    //                 checkcluster = true;
    //             } else {
    //                 // Check the type of the next tile
    //                 if (LevelObject.tiles[i][j].type == LevelObject.tiles[i][j + 1].type &&
    //                     LevelObject.tiles[i][j].type != -1) {
    //                     // Same type as the previous tile, increase matchlength
    //                     matchlength += 1;
    //                 } else {
    //                     // Different type
    //                     checkcluster = true;
    //                 }
    //             }

    //             // Check if there was a cluster
    //             if (checkcluster) {
    //                 if (matchlength >= 3) {
    //                     // Found a vertical cluster
    //                     this.clusters.push({
    //                         column: i, row: j + 1 - matchlength,
    //                         length: matchlength, horizontal: false
    //                     });
    //                 }

    //                 matchlength = 1;
    //             }
    //         }
    //     }
    // }

    // public swap(x1, y1, x2, y2) {
    //     let typeswap = LevelObject.tiles[x1][y1].type;
    //     LevelObject.tiles[x1][y1].type = LevelObject.tiles[x2][y2].type;
    //     LevelObject.tiles[x2][y2].type = typeswap;
    // }

    // public removeClusters(): void {


    //     // Change the type of the tiles to -1, indicating a removed tile
    //     // debugger
    //     this.loopClusters((index, column, row, cluster) => { LevelObject.tiles[column][row].type = -1; });

    //     // Calculate how much a tile should be shifted downwards
    //     for (var i = 0; i < LevelObject.columns; i++) {
    //         var shift = 0;
    //         for (var j = LevelObject.rows - 1; j >= 0; j--) {
    //             if (i == 0) {
    //             }
    //             // Loop from bottom to top
    //             if (LevelObject.tiles[i][j].type == -1) {
    //                 // Tile is removed, increase shift
    //                 shift++;
    //                 LevelObject.tiles[i][j].shift = 0;
    //                 // if(this.level.tiles[i][j].tile.explosion) {
    //                 //     await this.level.tiles[i][j].tile.explosion();
    //                 // }

    //             } else {
    //                 // Set the shift
    //                 LevelObject.tiles[i][j].shift = shift;
    //             }
    //         }
    //     }


    //     // // Change the type of the tiles to -1, indicating a removed tile
    //     // this.loopClusters(function (index, column, row, cluster) {
    //     //     const block = Game.instance.screen.getChildByName(LevelObject.tiles[column][row].name);
    //     //     gsap.to(block, {alpha: 0, duration: 0.3, ease: 'none', onComplete: () => {
    //     //         Game.instance.screen.removeChild(block);
    //     //     }})
    //     //     LevelObject.tiles[column][row].type = -1;
    //     // });

    //     // // Calculate how much a tile should be shifted downwards
    //     // for (let i = 0; i < LevelObject.columns; i++) {
    //     //     let shift = 0;
    //     //     for (let j = LevelObject.rows - 1; j >= 0; j--) {
    //     //         // Loop from bottom to top
    //     //         if (LevelObject.tiles[j][i].type == -1) {
    //     //             // Tile is removed, increase shift
    //     //             shift++;
    //     //             LevelObject.tiles[j][i].shift = 0;
    //     //         } else {
    //     //             // Set the shift
    //     //             LevelObject.tiles[j][i].shift = shift;
    //     //         }
    //     //     }
    //     // }
    // }

    // private loopClusters(func): void {
    //     for (let i = 0; i < this.clusters.length; i++) {
    //         //  { column, row, length, horizontal }
    //         let cluster = this.clusters[i];
    //         let coffset = 0;
    //         let roffset = 0;
    //         for (let j = 0; j < cluster.length; j++) {
    //             func(i, cluster.column + coffset, cluster.row + roffset, cluster);

    //             if (cluster.horizontal) {
    //                 coffset++;
    //             } else {
    //                 roffset++;
    //             }
    //         }
    //     }
    // }

    // public findMoves() {
    //     // Reset moves
    //     this.moves = []

    //     // Check horizontal swaps
    //     for (let j = 0; j < LevelObject.rows; j++) {
    //         for (let i = 0; i < LevelObject.columns - 1; i++) {
    //             // Swap, find clusters and swap back
    //             this.swap(i, j, i + 1, j);
    //             this.findClusters();
    //             this.swap(i, j, i + 1, j);

    //             // Check if the swap made a cluster
    //             if (this.clusters.length > 0) {
    //                 // Found a move
    //                 this.moves.push({ column1: i, row1: j, column2: i + 1, row2: j });
    //             }
    //         }
    //     }

    //     // Check vertical swaps
    //     for (let i = 0; i < LevelObject.columns; i++) {
    //         for (let j = 0; j < LevelObject.rows - 1; j++) {
    //             // Swap, find clusters and swap back
    //             this.swap(i, j, i, j + 1);
    //             this.findClusters();
    //             this.swap(i, j, i, j + 1);

    //             // Check if the swap made a cluster
    //             if (this.clusters.length > 0) {
    //                 // Found a move
    //                 this.moves.push({ column1: i, row1: j, column2: i, row2: j + 1 });
    //             }
    //         }
    //     }
    //     // Reset clusters
    //     this.clusters = []
    // }

    // public shiftTiles() {
    //     // Shift tiles
    //     for (let i = 0; i < LevelObject.columns; i++) {
    //         for (let j = LevelObject.rows - 1; j >= 0; j--) {
    //             // Loop from bottom to top
    //             if (LevelObject.tiles[j][i].type == -1) {
    //                 // Insert new random tile
    //                 LevelObject.tiles[j][i].type = this.getRandomTile(LevelObject.tiles[i][j]);
    //             } else {
    //                 // Swap tile to shift it
    //                 var shift = LevelObject.tiles[j][i].shift;
    //                 if (shift > 0) {
    //                     this.animText(LevelObject.tiles[j][i])
    //                     // this.swap(i, j, i, j+shift)
    //                 }
    //             }

    //             // Reset shift
    //             LevelObject.tiles[j][i].shift = 0;
    //         }
    //     }
    // }

    // private getRandomTile(tile: Block): number {
    //     const colors = DefaultConfig.colors;
    //     const color = colors[Math.floor(Math.random() * colors.length)]
    //     let sprite: Block;
    //     switch (color) {
    //         case 'red': {
    //             sprite = new Block(Main.instance.app.loader.resources.red.texture);
    //             sprite.color = 'red';
    //             sprite.type = 1;
    //             break;
    //         }
    //         case 'green': {
    //             sprite = new Block(Main.instance.app.loader.resources.pink.texture);
    //             sprite.color = 'green';
    //             sprite.type = 2;
    //             break;
    //         }
    //         case 'pink': {
    //             sprite = new Block(Main.instance.app.loader.resources.pink.texture);
    //             sprite.color = 'pink';
    //             sprite.type = 3;
    //             break;
    //         }
    //         case 'white': {
    //             sprite = new Block(Main.instance.app.loader.resources.white.texture);
    //             sprite.color = 'white';
    //             sprite.type = 4;
    //             break;
    //         }
    //         case 'yellow': {
    //             sprite = new Block(Main.instance.app.loader.resources.tile_5.texture);
    //             sprite.color = 'yellow';
    //             sprite.type = 5;
    //             break;
    //         }
    //     }

    //     // sprite.width = LevelObject.tilewidth - 5;
    //     // sprite.height = LevelObject.tileheight - 5;
    //     // sprite.x = tile.x;
    //     // sprite.y = 0;
    //     // sprite.alpha = 0;
    //     // sprite.moveToY = tile.moveToY;
    //     // sprite.row = tile.row;
    //     // sprite.col = tile.col;
    //     // sprite.stateMachine = new BlockStateMashine(sprite);
    //     // sprite.name = tile.name;
    //     // sprite.shift = 0;

    //     return sprite.type;
    // }

    // private animText(block) {
    //     gsap.to(block, { y: `+=${block.height * block.shift}`, duration: 2, ease: 'none' })
    // }
}